import { useEffect, useState } from 'react';
import * as offlinePunchQueue from '@src/db/offlinePunchQueue';

// 「IDB 是否還有未收尾的非同步打卡紀錄」訊號，給 _app 決定 firestore watcher / firebase chunk 要不要啟動。
// use_server_queue 關閉後，202 紀錄仍靠這個訊號維持監聽到收尾。
//
// 與 usePendingAsyncPunchKeys 的差別：不套 PENDING_LOCK_MAX_MS——那是按鈕 UI 解鎖上限，
// 監聽要一直維持到紀錄收尾（成功 / 失敗 / TTL）為止。
export default function useHasOutstandingAsyncPunch(accountId?: string): boolean {
	const [hasOutstanding, setHasOutstanding] = useState(false);

	useEffect(() => {
		if (!accountId) {
			setHasOutstanding(false);
			return undefined;
		}
		let cancelled = false;

		const refresh = async () => {
			let outstanding: offlinePunchQueue.LocalQueueRecord[];
			try {
				outstanding = await offlinePunchQueue.getOutstandingAsync(accountId);
			} catch (e) {
				// IDB 不可用（隱私模式 / storage 回收）→ 本輪略過
				return;
			}
			if (cancelled) return;
			setHasOutstanding(outstanding.length > 0);
		};

		refresh();
		const unsubscribe = offlinePunchQueue.subscribe(() => { refresh(); });
		return () => {
			cancelled = true;
			unsubscribe();
		};
	}, [accountId]);

	return hasOutstanding;
}
